// Elenco di annunci immobiliari della pagina list 

import { Component, OnInit, Input } from '@angular/core';
import { FillerService } from '../../common/Service_tnFiller';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
	selector: 'tn-ads-list-adv',
	templateUrl: '../../themes/default/html/tnadslistadv.component.html',
	styleUrls: ['../../themes/default/css/tnadslistadv.component.scss'],
})
export class TnadslistadvComponent implements OnInit {

	// pager object
	pager: any = {};

	// paged items
	pagedItems: Array<any>; //any[];



	AdvList: Array<any> = [];
	payload: any = {
		limit:0, 
		offset:0,
		listKind: "ALL", 
		priceRange:[],
		surfaceRange:[]
	};
    //   limit:0, 
    //   offset:0, 
    //   codes:[], 
    //   buildFloorsPlusThen:0,
    //   listKind: "HomeVisible", 
    //   adsIDs:[],
    //   categoryId:0,
    //   groupId:0, typeId:0,
    //   rentKindId:0,
    //   cityName:"",
    //   cityZoneId:0,
    //   conditioner:false,
    //   garage:false,
    //   garden:false,
    //   animalAdmit:false,
    //   balcony:false,
    //   bathroomsPlusThan:0,
    //   buildable:false,
    //   carParkPlusThan:0,
    //   lift:false,
    //   panoramic:false,
    //   priceRange:[],
    //   radiators:false,
    //   roomsPlusThan:0,
    //   surfaceRange:[],
    //   orderByKind:"Id",
    //   orderByDir:"ASC",
    //   uiCulture:"it"
    // };

	public myTitle: string = 'Annunci immobiliari';
	

	constructor(private filler: FillerService, private activatedRoute: ActivatedRoute) {
		//console.log ("SKIN = " + this.localskin); 
	}

	ngOnInit() {

		// Recupera tutta la querystriing per attivare i filtri
		new Promise((resolve, reject) => {
			this.activatedRoute.queryParams.subscribe((params: Params) => {
			
			this.payload.cityName = "";

			if (params['City']) { this.payload.cityName = params['City'] };
			if (params['Contract']) { this.payload.groupId = params['Contract'] };

			if (params['Category']) { this.payload.categoryId = params['Category'] };
			if (params['Type']) { this.payload.typeId = params['Type'] };
			
			this.payload.priceRange[0] = ((params['PriceRangeFrom'] != null || params['PriceRangeFrom'] != undefined) && params['PriceRangeFrom'] >0) ? params['PriceRangeFrom'] : 0 ;
			this.payload.priceRange[1] = ((params['PriceRangeTo'] != null || params['PriceRangeTo'] != undefined) && params['PriceRangeTo'] >0) ? params['PriceRangeTo'] : 10000000000 ;
			this.payload.surfaceRange[0] =((params['SurfaceRangeFrom'] !=null || params['SurfaceRangeFrom'] !=undefined ) && params['SurfaceRangeFrom'] >0 ) ? params['SurfaceRangeFrom'] : 0 ;
			this.payload.surfaceRange[1] =((params['SurfaceRangeTo'] !=null || params['SurfaceRangeTo'] !=undefined) && params['SurfaceRangeTo'] >0 ) ? params['SurfaceRangeTo'] : 10000000000 ;
			
			if (params['HasLift']) { this.payload.lift = params['HasLift'] };
			if (params['HasBalcony']) { this.payload.balcony = params['HasBalcony'] };
			if (params['IsPanoramic']) { this.payload.panoramic = params['IsPanoramic'] };
			if (params['HasGarden']) { this.payload.garden = params['HasGarden'] };
			if (params['HasRadiators']) { this.payload.radiators = params['HasRadiators'] };
			if (params['HasConditioner']) { this.payload.conditioner = params['HasConditioner'] };
			if (params['HasGarage']) { this.payload.garage = params['HasGarage'] };
			if (params['IsAnimalsAdmit']) { this.payload.animalAdmit = params['IsAnimalsAdmit'] };

			if (params['bathroomsPlusThan']) { this.payload.bathroomsPlusThan = params['bathroomsPlusThan'] };
			if (params['carParkPlusThan']) { this.payload.carParkPlusThan = params['carParkPlusThan'] };
			if (params['roomsPlusThan']) { this.payload.roomsPlusThan = params['roomsPlusThan'] };

			this.payload.uiCulture = "it";
			this.UpdateFiller();

			this.pager.pages = 0;
			resolve(true);
			
		});
		}).then(
			
		);
	}

	UpdateFiller() {
		new Promise((resolve, reject) => {
		this.filler.Get_AdsList(this.payload).subscribe(
			data => {
				this.AdvList = Object.assign([], data.Items)
				this.setPage(1);
				resolve(true);
			}, err => { console.log(err) }
			);
		}).then(
			e => console.log('adv')
		);
		
	}


	setPage(page: number) {

		//this.tasks = this.tasksBk;

        if (page < 1 || (this.pager.totalPages && page > this.pager.totalPages)) {
            return;
        }

        // get pager object from service
        this.pager = this.getPager(this.AdvList.length, page, 10);

        // get current page of items
		this.pagedItems = this.AdvList.slice(this.pager.startIndex, this.pager.endIndex + 1);
		
		// //console.log("PagedItems: " + this.pagedItems);
		// if (this.pager.LastPage) {
		// 	this.onPageChanged.emit( { CurrentPage: page, LastPage: true } );	
		// } else {
		// 	this.onPageChanged.emit( { CurrentPage: page, LastPage: false } );	
		// }

	}
	
	getPager(totalItems: number, currentPage: number = 1, pageSize: number = 10) {
        // calculate total pages
        let totalPages = Math.ceil(totalItems / pageSize);

		let IsLastPage = false;

        let startPage: number, endPage: number;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        let startIndex = (currentPage - 1) * pageSize;
        let endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
		let pages = []; //_.range(startPage, endPage + 1);
		for(var x=startPage; x<endPage + 1; x++ )  {
			pages.push(x);
		}

		if (currentPage == totalPages) {
			IsLastPage = true;
		}

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
			pages: pages,
			LastPage: IsLastPage
        };
	}

}






// WEBPACK FOOTER //
// A:/Work/Siti/Volpe2/src/app/components/tnadslistadv/tnadslistadv.component.ts